import { render, staticRenderFns } from "./DocumentRequest.vue?vue&type=template&id=cca3ebde&"
import script from "./DocumentRequest.vue?vue&type=script&lang=js&"
export * from "./DocumentRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports